import React from 'react'

import { MonzoUiThemeContext } from '../contexts/ThemeContext'

export function useTheme() {
  return React.useContext(MonzoUiThemeContext)
}
